/**
 * @param {vueInstance} context - This
 * @returns {Section}
 */
export default function (context) {
  return {
    key: 'demography_heading',
    resource: '',
    type: 'Section',
    title: {
      id: 'demography_heading',
      label: `${context.$t('demographics')} ${context.$tc('buyer', 2).toLowerCase()}`,
      icon: '',
      style: '',
    },
  }
}
